import { Button, PageHeader } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import {TeamOutlined} from '@ant-design/icons'

export default function EmployeeContracts() {
  const navigate = useNavigate()
  return (
    <>
    <PageHeader
    className="site-page-header"
    onBack={() => null}
    title="Employeement Contracts"
    subTitle="Find the list of employeement contracts"
    extra={<Button type='primary' onClick={()=>navigate('/addemployeecontract')}  icon={<TeamOutlined />}>Add Employeement contract</Button>}
  />
    </>
  )
}
